// extracted by mini-css-extract-plugin
export default {"container":"Home_container__HBi4-","table":"Home_table__BHkJE","categories":"Home_categories__a-H1M"};